module.exports = __webpack_public_path__ + "static/img/home_3d.e90f62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_3d.png
// module id = Swd+
// module chunks = 169